import useSWR from 'swr';
import { RequestQuery } from '@/data/types/RequestQuery';
import { RequestParams } from 'integration/generated/transactions/http-client';
import { transactionsDpvale } from 'integration/generated/transactions';
import { useSettings } from '@/data/Settings';
import { getClientSideCommon } from '@/data/utils/getClientSideCommon';
import { useNextRouter } from '@/data/Content/_NextRouter';
import { useExtraRequestParameters } from '@/data/Content/_ExtraRequestParameters';
import { PostDpvalePromotionBody } from 'integration/generated/transactions/data-contracts';
import { TransactionErrorResponse } from '@/data/types/Basic';

const postDpvalePromotionsFetcher =
	(pub: boolean) =>
	async (
		storeId: string,
		query: RequestQuery = {},
		data: PostDpvalePromotionBody,
		params: RequestParams
	) => {
		const res = await transactionsDpvale(pub).postDpvalePromotion(storeId, query, data, params);
		return res;
	};

const DATA_KEY_DP_VALE_PROMOTIONS = 'dpValePromotions';

export const useDpvalePromotion = (args?: PostDpvalePromotionBody) => {
	const { settings } = useSettings();
	const router = useNextRouter();
	const { storeId } = getClientSideCommon(settings, router);
	const params = useExtraRequestParameters();

	const rawSwr = useSWR(
		storeId && args ? [{ storeId, ...args }, DATA_KEY_DP_VALE_PROMOTIONS] : null,
		async ([{ storeId, ...data }]) => {
			try {
				const response = await postDpvalePromotionsFetcher(true)(storeId, {}, data, params);
				return {
					promotions: response?.data,
					promotionsError: undefined,
				};
			} catch (error) {
				const promotionsError = error as TransactionErrorResponse;
				return {
					promotions: undefined,
					promotionsError,
				};
			}
		},
		{ revalidateOnMount: true }
	);

	return {
		...rawSwr,
	};
};
